import { msEmployee, msFteOrVendorEmployee } from '../../constants';
export var carpoolServiceToUiAdapter = function (carpoolData) { return ({
    licensePlate: carpoolData.licensePlate,
    groupId: carpoolData.groupId,
    groupOwnerAlias: carpoolData.groupOwnerAlias,
    id: carpoolData.id,
    carpoolMembers: carpoolData.carpoolMembers.map(function (item) { return ({
        memberType: item.memberType === msEmployee ? msFteOrVendorEmployee : item.memberType,
        memberAlias: item === null || item === void 0 ? void 0 : item.memberAlias,
        originCity: item.originCity,
        permitNumber: item.permitNumber,
        email: item === null || item === void 0 ? void 0 : item.email,
    }); }),
    carpoolPolicyChecked: false,
}); };
export var carpoolUiToServiceAdapter = function (carpoolData) { return ({
    licensePlate: carpoolData.licensePlate,
    groupId: carpoolData.groupId,
    groupOwnerAlias: carpoolData.groupOwnerAlias,
    id: carpoolData.id,
    carpoolMembers: carpoolData.carpoolMembers.map(function (item) { return ({
        memberType: item.memberType === msFteOrVendorEmployee ? msEmployee : item.memberType,
        memberAlias: item === null || item === void 0 ? void 0 : item.memberAlias,
        originCity: item.originCity,
        permitNumber: item.permitNumber || 'Unassigned',
        email: item === null || item === void 0 ? void 0 : item.email,
    }); }),
}); };
